import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-list-item',

  imports: [CommonModule],
  templateUrl: './list-item.component.html',
  styleUrl: './list-item.component.scss',
})
export class ListItemComponent {
  title = input.required<string>();
  subtitle = input<string>();
  meta = input<string>();
  trailing = input<string>();
  secondary = input<string>();
  compact = input(false);
}
